(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["puckBundle"] = factory(require("jQuery"));
	else
		root["puckBundle"] = factory(root["jQuery"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__44786__) => {
return 